import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';

// modules 自动注册
const requireAll = requireContext => requireContext.keys().map(requireContext);
const req = require.context('./modules', true, /\.js$/);
const modules = {};

requireAll(req).map(md => {
    modules[md.default.name] = md.default;
    modules[md.default.name].mutations = mutations;
});
Vue.use(Vuex);
const store = new Vuex.Store({
    modules,
    getters: {
        userInfo: state => state.user.userInfo,
    },
});

export default store;
